import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
          不想错过任何福利？
        </h2>
        <p className="text-sm md:text-base text-foreground-600 mb-6 max-w-lg mx-auto">
          我们的团队每日追踪全网最新福利资源，确保您第一时间获取最实用的优惠信息。
        </p>
        <Link
          to="/category/dianshang-youhui"
          className="inline-flex items-center px-6 py-3 rounded-md text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
        >
          立即浏览
          <i className="ri-arrow-right-line ml-2"></i>
        </Link>
      </div>
    </section>
  );
}